<template>
  <div class="label-list">
    <div class="left">
      <div
        class="icon"
        :class="{ active:  navIndex === index, all: index === 2, common: index === 1 }"
        v-for="(item, index) in menuList"
        @click="toggleMenu(index)"
        :key="index"
      >
        <i></i>
        <p>{{ item }}</p>
      </div>
      <h3 class="title">
        标签分组
        <i class="el-icon-plus" @click="addLabelGroup"></i>
      </h3>
      <ul>
        <li
          v-for="(item, index) in labelTitleList"
          @click="changeLabel(item, index)"
          :class="{ edit: item.isEdit, active: index + 3 === navIndex }"
          :key="index"
        >
          <p v-show="!item.isEdit">{{ item.group_name }}</p>
          <input
            type="text"
            v-show="item.isEdit"
            class="el-input__inner"
            v-model="item.newName"
            placeholder="请输入标签分组名称"
          />
          <div class="tools" v-show="item.group_id !== 0">
            <i class="edit" @click="item.isEdit = true" v-show="!item.isEdit"></i>
            <i class="okay" @click="saveEdit(item)" v-show="item.isEdit"></i>
            <i class="delete" @click="deleteLabelGroup(item)"></i>
          </div>
        </li>
      </ul>
    </div>

    <div class="right">
      <div class="hot-tag-list label-main-list" v-show="navIndex === 0">
        <div class="tools">
          <el-button
            v-show="hotTagDeleteShow"
            type="danger"
            size="small"
            plain
            @click="deleteHotTag"
            icon="el-icon-delete"
          >删除</el-button>
        </div>
        <div class="label-main-item">
          <h3 class="title">
            <p>热门标签</p>
            <i class="el-icon-plus" @click="hotAddShow = !hotAddShow" slot="reference"></i>
            <div class="add-box" v-show="hotAddShow">
              <input
                type="text"
                class="el-input__inner"
                @keyup.enter="addHotTag"
                v-model="hotTagName"
                @input="filterHotList"
                placeholder="请输入标签名称"
              />
              <div class="tools-box">
                <a class="cancel" @click="hotTagName = '', hotAddShow = false">取消</a>
                <a @click="addHotTag">确定</a>
              </div>

              <div class="search-list" v-show="searchShow && searchList.length > 0">
                <div
                  class="search-item"
                  v-for="(item, index) in searchList"
                  @click="addHotTag(item)"
                  :key="index"
                >{{ item.name }}</div>
              </div>
            </div>
          </h3>
          <div class="label-item-list">
            <div
              class="label-item"
              :class="{ active: item.active, 'hot-tag': item.is_hot }"
              v-for="(item, index) in hotTagList"
              @click="addHotTagSelect(item)"
              :key="index"
            >{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="common-tag-list label-main-list" v-show="navIndex === 1">
        <div class="tools">
          <el-button
            v-show="commonTagDeleteShow"
            type="danger"
            size="small"
            plain
            @click="deleteCommonTag"
            icon="el-icon-delete"
          >删除</el-button>
        </div>
        <div class="label-main-item">
          <h3 class="title">
            <p>常用标签</p>
            <i class="el-icon-plus" @click="commonAddShow = !commonAddShow" slot="reference"></i>
            <div class="add-box" v-show="commonAddShow">
              <input
                type="text"
                class="el-input__inner"
                @keyup.enter="addCommonTag"
                v-model="commonTagName"
                @input="filterCommonList"
                placeholder="请输入标签名称"
              />
              <div class="tools-box">
                <a class="cancel" @click="commonTagName = '', commonAddShow = false">取消</a>
                <a @click="addCommonTag">确定</a>
              </div>

              <div class="search-list" v-show="commonSearchShow && commonSearchList.length > 0">
                <div
                  class="search-item"
                  v-for="(item, index) in commonSearchList"
                  @click="addCommonTag(item)"
                  :key="index"
                >{{ item.name }}</div>
              </div>
            </div>
          </h3>
          <div class="label-item-list">
            <div
              class="label-item"
              :class="{ active: item.active, 'hot-tag': item.is_hot }"
              v-for="(item, index) in commonTagList"
              @click="addCommonTagSelect(item)"
              :key="index"
            >{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="label-main-list" v-show="navIndex >= 2">
        <div class="tools" v-show="selectList.length > 0">
          <el-button type="danger" size="small" plain @click="deleteLabel" icon="el-icon-delete">删除</el-button>
          <el-select @change="moveLabel" class="white" size="small" v-model="move" placeholder="移动">
            <el-option
              v-for="(item, index) in labelTitleList"
              :key="index"
              :label="item.group_name"
              :value="index"
            ></el-option>
          </el-select>
        </div>
        <div class="label-main-item" v-for="(item, index) in labelList" :key="index">
          <h3 class="title">
            <p>{{ item.group_name }}</p>
            <i class="el-icon-plus" @click="item.addShow = !item.addShow" slot="reference"></i>
            <div class="add-box" v-show="item.addShow">
              <input
                type="text"
                class="el-input__inner"
                v-model="item.labelName"
                placeholder="请输入标签名称"
              />
              <div class="tools-box">
                <a class="cancel" @click="item.addShow = false">取消</a>
                <a @click="addLabel(item)">确定</a>
              </div>
            </div>
          </h3>
          <!-- <h3 class="title">
            {{ item.group_name }}
            <el-popover v-model="item.addShow" placement="bottom-start" width="200" trigger="click">
              <i class="el-icon-plus" slot="reference"></i>
              <div class="add-label">
                <input
                  type="text"
                  class="el-input__inner"
                  v-model="item.labelName"
                  placeholder="请输入标签名称"
                />
                <div class="tools">
                  <a class="cancel" @click="item.addShow = false">取消</a>
                  <a @click="addLabel(item)">确定</a>
                </div>
              </div>
            </el-popover>
          </h3>-->
          <div class="label-item-list">
            <div
              class="label-item"
              :class="{ active: it.active, 'hot-tag': it.is_hot }"
              v-for="(it, idx) in item.labels"
              @click="addSelect(it)"
              :key="idx"
            >{{ it.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getLabelGroupList,
  addLabelGroup,
  editLabelGroup,
  deleteLabelGroup,
  addLabel,
  deleteLabel,
  updateLabelGroup,
  getHotTagList,
  addHotTag,
  deleteHotTag,
  getCommonTagList,
  addCommonTag,
  deleteCommonTag
} from "../assets/js/api";
import { PromiseWidget } from "../assets/js/tools";
export default {
  props: {
    update: {
      type: Number,
      default: 0
    }
  },
  watch: {
    update(val) {
      this.getLabelGroupList();
    }
  },
  computed: {
    hotTagDeleteShow() {
      return this.hotTagList.filter(item => item.active).length > 0;
    },
    commonTagDeleteShow() {
      return this.commonTagList.filter(item => item.active).length > 0;
    }
  },
  data() {
    return {
      menuList: ["热门标签", "常用标签", "全部"],
      labelList: [],
      navIndex: 2,
      selectList: [],
      move: "",
      hotAddShow: false,
      hotTagName: "",
      hotTagList: [],
      labelTitleList: [],
      allLabelList: [],
      currentItem: {},
      filterTimeout: {},
      searchList: [],
      searchShow: false,
      commonAddShow: false,
      commonTagName: "",
      commonTagList: [],
      commonSearchShow: false,
      commonSearchList: [],
      commonFilterTimeout: null
    };
  },
  created() {
    // this.getHotTagList();
    this.getLabelGroupList();
  },
  methods: {
    deleteCommonTag() {
      this.$confirm(`确定要删除常用标签吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const temp = [];
          this.commonTagList
            .filter(item => item.active)
            .map(item => {
              temp.push(item.id);
            });
          const [err, data] = await PromiseWidget.to(
            deleteCommonTag(temp.join(","))
          );
          if (data.code === 200) {
            this.$message.success("删除常用标签成功");
            this.getCommonTagList();
          }
        })
        .catch(() => {});
    },
    addCommonTagSelect(item) {
      item.active = !item.active;
    },
    async getCommonTagList() {
      const data = await getCommonTagList();
      if (data.code === 200) {
        data.data.map(item => {
          item.active = false;
        });
        this.commonTagList = data.data;
      }
    },
    filterCommonList() {
      window.clearTimeout(this.commonFilterTimeout);
      this.commonSearchShow = true;
      this.commonFilterTimeout = window.setTimeout(() => {
        const labelList = JSON.parse(JSON.stringify(this.labelTitleList));
        const result = [];
        labelList.map(item => {
          item.labels.map(it => {
            if (it.name.includes(this.commonTagName)) {
              result.push(it);
            }
          });
        });

        this.commonSearchList = result;
      }, 300);
    },
    async addCommonTag(item = {}) {
      this.commonSearchShow = false;
      const [err, data] = await PromiseWidget.to(
        addCommonTag(item.id ? item.id : this.commonTagName)
      );
      if (data.code === 200) {
        this.$message.success("新增常用标签成功");
        this.commonTagName = "";
        this.commonAddShow = false;
        this.getCommonTagList();
      } else {
        this.$message.warning(data.msg);
      }
    },
    filterHotList() {
      window.clearTimeout(this.filterTimeout);
      this.searchShow = true;
      this.filterTimeout = window.setTimeout(() => {
        const labelList = JSON.parse(JSON.stringify(this.labelTitleList));
        const result = [];
        labelList.map(item => {
          item.labels.map(it => {
            if (it.name.includes(this.hotTagName)) {
              result.push(it);
            }
          });
        });

        this.searchList = result;
      }, 300);
    },
    async changeLabel(item, index) {
      this.currentItem = item;
      this.selectList = [];
      const [err, data] = await PromiseWidget.to(
        getLabelGroupList(this.currentItem.group_id)
      );
      if (data.code === 200) {
        this.navIndex = index + 3;
        data.data.map(item => {
          item.newName = item.group_name;
          item.isEdit = false;
          item.addShow = false;
          item.labelName = "";

          item.labels.map(it => {
            it.active = false;
          });
        });
        this.labelList = data.data;
      }
    },
    deleteHotTag() {
      this.$confirm(`确定要删除热门标签吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const temp = [];
          this.hotTagList
            .filter(item => item.active)
            .map(item => {
              temp.push(item.id);
            });
          const [err, data] = await PromiseWidget.to(
            deleteHotTag(temp.join(","))
          );
          if (data.code === 200) {
            this.$message.success("删除热门标签成功");
            this.getHotTagList();
          }
        })
        .catch(() => {});
    },
    addHotTagSelect(item) {
      item.active = !item.active;
    },
    async getHotTagList() {
      const data = await getHotTagList();
      if (data.code === 200) {
        data.data.map(item => {
          item.active = false;
        });
        this.hotTagList = data.data;
      }
    },
    async addHotTag(item = {}) {
      this.searchShow = false;
      const [err, data] = await PromiseWidget.to(
        addHotTag(item.id ? item.id : this.hotTagName)
      );
      if (data.code === 200) {
        this.$message.success("新增热门标签成功");
        this.hotTagName = "";
        this.hotAddShow = false;
        this.getHotTagList();
      } else {
        this.$message.warning(data.msg);
      }
    },
    toggleMenu(index) {
      this.navIndex = index;
      this.currentItem = {};
      switch (this.navIndex) {
        case 0:
          this.getHotTagList();
          break;
        case 1:
          this.getCommonTagList();
          break;
        case 2:
          this.getLabelGroupList();
          break;
      }
    },
    async moveLabel() {
      const temp = [];
      this.selectList.map(item => {
        temp.push(item.id);
      });
      const params = {
        label_ids: temp,
        group_id: this.labelTitleList[this.move].group_id
      };
      const [err, data] = await PromiseWidget.to(updateLabelGroup(params));

      if (data.code === 200) {
        this.$message.success("更改标签分组成功");
        this.selectList = [];
        this.getLabelGroupList();
      } else {
        this.$message.warning("更改标签分组失败，请重试!");
      }
      this.move = "";
    },
    deleteLabel() {
      this.$confirm(`确定要删除标签吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const temp = [];
          this.selectList.map(item => {
            temp.push(item.id);
          });
          const [err, data] = await PromiseWidget.to(
            deleteLabel(temp.join(","))
          );
          if (data.code === 200) {
            this.selectList = [];
            this.$message.success("删除标签成功");
            this.getLabelGroupList();
          }
        })
        .catch(() => {});
    },
    addSelect(item) {
      if (item.active) {
        let index = -1;
        this.selectList.map((it, idx) => {
          if (it.id === item.id) {
            index = idx;
          }
        });

        index > -1 && this.selectList.splice(index, 1);
      } else {
        this.selectList.push(item);
      }

      item.active = !item.active;
    },
    async addLabel(item) {
      const params = {
        group_id: item.group_id,
        label_name: item.labelName
      };
      const [err, data] = await PromiseWidget.to(addLabel(params));
      if (data.code === 200) {
        this.$message.success("新增标签成功");
        item.labelName = "";
        this.getLabelGroupList();
      } else {
        this.$message.warning(data.msg);
      }
    },
    async addLabelGroup() {
      const [err, data] = await PromiseWidget.to(addLabelGroup("未命名分组"));
      if (data.code === 200) {
        this.$message.success("新增标签分组成功");
        this.getLabelGroupList();
      }
    },
    deleteLabelGroup(item) {
      if (item.isEdit) {
        item.isEdit = false;
        item.newName = item.group_name;
      } else {
        this.$confirm(`确定要删除“${item.group_name}”吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            console.log(1);
            const [err, data] = await PromiseWidget.to(
              deleteLabelGroup(item.group_id)
            );
            if (data.code === 200) {
              this.$message.success("删除标签分组成功");
              this.getLabelGroupList();
            }
          })
          .catch(() => {});
      }
    },
    async saveEdit(item) {
      const params = {
        group_id: item.group_id,
        group_name: item.newName
      };
      const loading = this.$loading({
        lock: true,
        text: "正在编辑分组...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const [err, data] = await PromiseWidget.to(editLabelGroup(params));
      this.$nextTick(() => {
        loading.close();
      });
      if (data.code === 200) {
        this.$message.success("编辑标签分组成功");
        this.getLabelGroupList();
        item.isEdit = false;
      }
    },
    async getLabelGroupList() {
      const [err, data] = await PromiseWidget.to(
        getLabelGroupList(
          typeof this.currentItem.group_id === "number"
            ? this.currentItem.group_id
            : -1
        )
      );
      if (data.code === 200) {
        data.data.map(item => {
          item.newName = item.group_name;
          item.isEdit = false;
          item.addShow = false;
          item.labelName = "";

          item.labels.map(it => {
            it.active = false;
          });
        });
        this.labelTitleList =
          typeof this.currentItem.group_id === "number"
            ? this.labelTitleList
            : JSON.parse(JSON.stringify(data.data));
        this.labelList = data.data;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.label-list {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  background-color: #fff;
  .left {
    width: 222px;
    height: calc(100vh - 60px);
    border-right: 1px solid #dcdfe6;
    padding: 20px 10px;
    box-sizing: border-box;
    .icon {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 30px;
      padding: 0 10px;
      border-radius: 5px;
      cursor: pointer;
      margin-bottom: 2px;
      &:hover,
      &.active {
        background-color: #eaeaea;
      }
      i {
        width: 20px;
        height: 20px;
        background: url(../assets/images/hot-icon.png) no-repeat center center;
      }
      p {
        color: #606266;
        font-size: 14px;
        margin-left: 10px;
      }

      &.all {
        margin-bottom: 0;
        i {
          background-image: url(../assets/images/label-all-icon.png);
        }
      }

      &.common {
        i {
          background-image: url(../assets/images/common-tag-icon.png);
        }
      }
    }
    .all {
    }

    h3.title {
      color: #909399;
      font-size: 14px;
      font-weight: 400;
      margin: 10px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      i {
        color: #685b5b;
        font-size: 14px;
        cursor: pointer;
        font-weight: 600;
        &:hover {
          color: #1983f9;
        }
      }
    }

    ul {
      margin-top: 15px;
      list-style: none;
      padding: 0;
      li {
        padding-left: 10px;

        text-align: left;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover,
        &.edit {
          background-color: #eaeaea;
          i {
            display: block;
          }
        }

        &.active {
          background-color: #eaeaea;
        }

        .tools {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        p {
          margin: 0;
          color: #303133;
        }

        .el-input__inner {
          height: 20px;
          line-height: 20px;
          border: 0;
          padding: 0;
          width: 120px;
          min-width: 120px;
        }

        i {
          display: none;
          width: 14px;
          height: 14px;
          &.edit {
            background: url(../assets/images/label-group-edit-icon.png)
              no-repeat;
          }

          &.okay {
            background: url(../assets/images/label-group-okay-icon.png)
              no-repeat;
          }

          &.delete {
            background: url(../assets/images/label-group-delete-icon.png)
              no-repeat;
            margin: 0 4px 0 10px;
          }
        }
      }
    }
  }

  .right {
    padding: 0 20px;
    flex: 1;
    text-align: left;
    overflow-y: auto;
    height: calc(100vh - 60px);
    box-sizing: border-box;

    .label-main-list {
      position: relative;
      .tools {
        position: absolute;
        right: 0;
        top: 23px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-button {
          font-size: 14px;
        }

        .el-select {
          margin-left: 20px;
        }
      }
    }
    .label-main-item {
      width: 100%;
      padding: 30px 0 20px;
      border-bottom: 1px solid #dcdfe6;

      h3.title {
        color: #303133;
        font-size: 16px;
        font-weight: 400;
        margin: 0 0 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 32px;
        line-height: 32px;
        p {
          margin: 0;
        }
        .add-box {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex: 1;
          position: relative;

          .search-list {
            position: absolute;
            left: 0;
            top: 31px;
            width: 240px;
            max-height: 170px;
            overflow-y: auto;
            background-color: #fff;
            z-index: 999;
            border-radius: 5px;
            box-shadow: 0px 2px 4px rgba(76, 83, 91, 0.1);
            border: 1px solid #dcdfe6;
            padding-top: 10px;

            .search-item {
              cursor: pointer;
              height: 40px;
              line-height: 40px;
              padding-left: 30px;
              color: #606266;
              &:hover {
                background-color: #eaeaea;
                color: #1983f9;
              }
            }
          }
          .el-input__inner {
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            text-indent: 0;
            width: 240px;
            margin-right: 10px;
          }

          .tools-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            a {
              margin-right: 10px;
              color: #1983f9;
              cursor: pointer;
              font-size: 14px;
              &.cancel {
                color: #909399;
              }
            }
          }
        }
        i {
          color: #685b5b;
          font-size: 14px;
          margin: 0 10px;
          cursor: pointer;
          font-weight: 600;
          &:hover {
            color: #1983f9;
          }
        }
      }
    }

    .label-item-list {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .label-item {
        padding: 0 10px;
        border: 1px solid #bfbfbf;
        background-color: #f8f8f8;
        border-radius: 5px;
        color: #606266;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        margin: 0 20px 10px 0;
        cursor: pointer;

        &.hot-tag {
          color: #fff;
          border-color: #ff6029;
          background: linear-gradient(
            135deg,
            rgba(250, 213, 44, 1) 0%,
            rgba(255, 96, 41, 1) 100%
          );
          position: relative;

          &:after {
            position: absolute;
            right: -8px;
            top: -7px;
            content: " ";
            width: 20px;
            height: 14px;
            background: url(../assets/images/hot-tag-icon.png) no-repeat center
              center;
          }

          &.active {
            background: #fff;
            color: #ff6029;
            border-color: #ff6029;
          }
        }
        &:hover,
        &.active {
          border: 1px solid #1983f9;
        }
      }
    }
  }
}

.add-label {
  input {
    height: 32px;
    line-height: 32px;
    padding: 0;
  }

  .tools {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    a {
      color: #1983f9;
      font-size: 14px;
      cursor: pointer;
      &.cancel {
        color: #909399;
        margin-right: 10px;
      }
    }
  }
}
</style>